<template>
  <AccountPanel title="Opiekun handlowy">
    <h5 class="card-title">
      {{ keeper.forname }} {{ keeper.surname }} <{{ keeper.email }}>
    </h5>
    <p class="card-text">Telefon: {{ keeper.phone }}</p>
    <p class="card-text">Telefon firmowy: {{ keeper.company.phone }}</p>
    <div style="display:inline-block">
      <b-button size="sm" @click="show()" variant="primary" right
        >Napisz wiadomość</b-button>
      <b-button size="sm" variant="primary" right href="messages/">Historia wiadomości</b-button>
    </div>
    <div v-if="isShown">
      <br/>
      <input type = "text" class = "form-control" placeholder="Tytuł wiadomości" v-model = "title"/>
      <b-form-textarea
        id="textarea-keeper" v-model = "message" placeholder="Napisz wiadomość" rows="3" maxRows="6"></b-form-textarea>
      <div class = "panel-button">
        <b-button size = "sm" variant="primary" right name = "submit">Wyślij</b-button>
      </div>
    </div>
  </AccountPanel>
</template>

<script>
  import { mapState } from "vuex";
  import AccountPanel from "./AccountPanel.vue";
  import {BFormTextarea} from "bootstrap-vue/esm/components/form-textarea/form-textarea";
  import {BButton} from "bootstrap-vue/esm/components/button/button";


  export default {
    props: ["id"],
    components: { AccountPanel, "b-form-textarea": BFormTextarea, BButton },
    data() {
      return {
        isShown: false,
        title: "",
        message: "",
        keeper: {
          forname: "",
          surname: "",
          email: "",
          phone: "",
          company: {
            phone: ""
          }
        }
      };
    },
    computed: {
      ...mapState({
        user: state => state.user.authorizedUser,
        keper: state => state.user.keeper
      })
    },
    async beforeMount() {
      await this.$store.dispatch("user/getKeeper");
      this.keeper = Object.assign(this.keper);
    },
    methods:{
      show(){
        if(this.isShown == false){
           return this.isShown = true;
        } else if(this.isShown == true){
          return this.isShown = false;
        }
      }
    }
  };
</script>



// WEBPACK FOOTER //
// src/components/account/src/account/KeeperData.vue